import React, { useMemo, useEffect, useState } from 'react';

import { toFixed } from '_dash';
import img from '../../../../../assets/bgfinal.png';

import './style.scss';

const ProfileCover = React.memo(({ detail }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const image = useMemo(() => {
    if (detail.shop) {
      return `${detail.cover_photo}?w=800&h=288&c=fit&q=auto:good&f=auto`;
    }
    if (detail.portfolio?.cover_image) {
      return `${detail.portfolio.cover_image}?w=800&h=288&c=fit&q=auto:good&f=auto`;
    }
    return img;
  }, [detail?.cover_photo, detail.portfolio?.cover_image, detail?.shop]);

  // Preload the image
  useEffect(() => {
    if (image) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = image;
      document.head.appendChild(link);

      return () => {
        document.head.removeChild(link);
      };
    }
  }, [image]);

  return (
    <div className='profile-cover'>
      <div className='cover-wrapper'>
        {image && (
          <img
            className='cover'
            src={image}
            alt='Profile Cover'
            height='288'
            style={{ display: imageLoaded ? 'block' : 'none' }}
            onLoad={() => setImageLoaded(true)}
          />
        )}
      </div>
      <div className='review-badge text-xl'>
        <p className='text-xl semi-bold'>{toFixed(detail.avg_rating || 0, 1)}</p>
        <p>{detail.number_reviews || 0} reviews</p>
      </div>
    </div>
  );
});

export default ProfileCover;
